import {AxiosResponse} from 'axios';
import {CommercialPackagesModel} from 'library/src/commercialPackages/models/CommercialPackagesModel';
import api, {wagoNestApiUrl} from 'shared/services/ApiConfig';
import PixagriScopes from '../../../library/src/core/models/PixagriScopes';

export class PixagriCommercialPackagesApiService {
  getBaseUrl() {
    return `${wagoNestApiUrl}/${PixagriScopes.COMMERCIAL_PACKAGES}`;
  }

  getCommercialPackagesUrl() {
    let baseUrl = this.getBaseUrl();
    return baseUrl;
  }

  async getCommercialPackages(): Promise<CommercialPackagesModel[]> {
    const url = this.getCommercialPackagesUrl();
    const res: AxiosResponse<CommercialPackagesModel[]> = await api.get(url);
    return res.data;
  }
}

const pixagriCommercialPackagesApiService =
  new PixagriCommercialPackagesApiService();
export default pixagriCommercialPackagesApiService;
